import LegalLayout from "@/components/LegalLayout";

function H2({ children }) {
  return (
    <h2 className="mt-10 font-heading text-2xl md:text-3xl"
      style={{ fontVariationSettings: "'opsz' 64, 'wght' 500", color: "var(--ink)" }}>{children}</h2>
  );
}

function P({ children }) { return <p>{children}</p>; }

export default function Refund() {
  return (
    <LegalLayout
      eyebrow="iii. The safety net"
      title="Refund &"
      italic="cancellation."
      lastUpdated="July 17, 2026"
      testid="refund-page"
    >
      <P>
        We want you to try PintaFlow with zero risk. If a paid plan isn&apos;t working for you within the first week, we&apos;ll refund it — no questions, no forms, no guilt.
      </P>

      <H2>1. Free tier — nothing to refund</H2>
      <P>
        PintaFlow&apos;s Starter plan is free forever. There is no charge, so there is nothing to refund. You can stop using the app any time and your data stays yours.
      </P>

      <H2>2. 7-day money-back guarantee (paid plans)</H2>
      <P>
        When paid plans launch, every new subscription comes with a <strong style={{ color: "var(--ink)" }}>7-day refund window</strong> from the date of your first payment. If you decide PintaFlow isn&apos;t right for you within those 7 days, we will refund the full amount to your original payment method.
      </P>
      <ul className="list-disc pl-6 space-y-2">
        <li>Applies to the <strong style={{ color: "var(--ink)" }}>first subscription payment</strong> only.</li>
        <li>Renewals (monthly or annual) are non-refundable once billed — but you can cancel at any time to stop future charges.</li>
        <li>Refund is processed to the original payment method (UPI / Card / Razorpay) and lands within <strong style={{ color: "var(--ink)" }}>5-7 business days</strong>.</li>
        <li>You do not need to explain your reason — a one-line email is enough.</li>
      </ul>

      <H2>3. How to request a refund</H2>
      <P>
        Email <a href="mailto:hello@pintaflow.com" style={{ color: "var(--seal)" }}>hello@pintaflow.com</a> from the email you used to sign up. Subject line <em>&quot;Refund&quot;</em> is enough. We will confirm within 24 hours and initiate the refund the same day.
      </P>

      <H2>4. Cancelling your subscription</H2>
      <P>
        You can cancel any time from <strong style={{ color: "var(--ink)" }}>Settings → Billing</strong>. Your paid features remain active until the end of the current billing cycle. Your workspace data is never deleted just because you downgrade — everything stays put on the free tier.
      </P>

      <H2>5. Chargebacks</H2>
      <P>
        If something goes wrong, please email us first — we would rather refund you directly than deal with a bank chargeback. A chargeback filed without contacting us may result in your account being suspended.
      </P>

      <H2>6. Exceptions</H2>
      <P>
        Refunds are not available in the following cases:
      </P>
      <ul className="list-disc pl-6 space-y-2">
        <li>Requests made more than 7 days after your first payment.</li>
        <li>Renewal payments (only your first payment is covered).</li>
        <li>Accounts terminated for violating our <a href="/terms" style={{ color: "var(--seal)" }}>Terms of Service</a>.</li>
      </ul>

      <H2>7. Changes to this policy</H2>
      <P>
        If we ever change this policy (only to make it clearer or more generous), the &quot;Last updated&quot; date above will change and existing customers will be emailed. Existing subscriptions will be honoured under the policy that was in effect when you paid.
      </P>

      <H2>8. Contact</H2>
      <P>
        Email <a href="mailto:hello@pintaflow.com" style={{ color: "var(--seal)" }}>hello@pintaflow.com</a>. Pradeep replies personally — usually the same day.
      </P>
    </LegalLayout>
  );
}
